import moment from 'moment';
import { useIntl } from 'react-intl';

const useChangeHandler = (setState) => {
  const onChangeHandler = (event) => {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    setState((prevState) => ({ ...prevState, [`${name}`]: value }));
  };

  return onChangeHandler;
};

const useFormatMessage = (
  id,
  values = {},
  defaultMessage = '',
  description = ''
) => {
  const intl = useIntl();
  return intl.formatMessage({ id, defaultMessage, description }, values);
};

// const useFormatDate = (value, options = {}) => {
const useFormatDate = (value) => {
  // const intl = useIntl();
  // return intl.formatDate(value, options);
  const date = moment(value);
  if (!date.isValid()) {
    return '';
  }
  return date.format('DD-MM-YYYY');
};

const useFormatDateTime = (value) => {
  const date = moment.utc(value);
  if (!date.isValid()) {
    return '';
  }
  return date.format('DD-MM-YYYY HH[h]mm');
};

const useFormatDateTimeSecond = (value) => {
  const date = moment.utc(value);
  if (!date.isValid()) {
    return '';
  }
  return date.format('DD-MM-YYYY HH[h]mm[m]ss[s]');
};

const useFormatDifferenceTime = (value) => {
  const date = moment.utc(value).fromNow();
  return date;
};

const useFormatAddress = (value) => {
  if (!value) {
    return '';
  }

  const { line1, line2, postalCode, city, country } = value;
  return `${line1 ? `${line1}, ` : ''}${line2 || ''}${
    postalCode || ''
  } ${city} ${country ? `, ${country}` : ''}`;
};

const useFormatContact = (contact) => {
  if (!contact) {
    return '';
  }

  const {
    firstName = '',
    lastName = '',
    phoneNumber = '',
    email = '',
  } = contact;
  return `${firstName} ${lastName.toUpperCase()} 
  ${phoneNumber ? `, ${phoneNumber}` : ''} ${email ? `- ${email}` : ''}`;
};

const useFormatUserName = (user) => {
  if (!user) {
    return '';
  }

  const { firstName = '', lastName = '' } = user;
  return `${firstName} ${lastName}`;
};

export {
  useChangeHandler,
  useFormatMessage,
  useFormatDate,
  useFormatDateTime,
  useFormatDateTimeSecond,
  useFormatDifferenceTime,
  useFormatAddress,
  useFormatContact,
  useFormatUserName,
};
